module.exports = __webpack_public_path__ + "img/art2.8b845925.jpg";